import { useCallback } from "react";
import useSWRImmutable from "swr/immutable";
import useSWRMutation from "swr/mutation";
import { Paginated, PaginationQuery } from "../../types";
import { buildUrl, useApi } from "../api";
import { CustomError } from "../errors";
import { UpsertUser, User } from "./types";

export const useUsersApi = () => {
  const api = useApi();

  const getAdminUser = useCallback(
    (userId: string, signal: AbortSignal) => {
      const url = `/admin/users/${userId}`;
      return useSWRMutation<User, CustomError, string>(url, (url) => api.get<User>({ url, signal }));
    },
    [api]
  );

  const useAdminUsers = useCallback(
    (query: PaginationQuery, signal: AbortSignal) => {
      const url = buildUrl("/admin/users", query);
      return useSWRImmutable<Paginated<User>, CustomError, string>(url, (url) =>
        api.get<Paginated<User>>({ url, signal })
      );
    },
    [api]
  );

  // const insertAdminUser = useCallback(
  //   async (body: UpsertUser): Promise<{ id: string }> => {
  //     const url = `/admin/users`;
  //     const id = await api.post<UpsertUser, { id: string }>(url, body);
  //     api.mutateCache([url]);
  //     return id;
  //   },
  //   [api]
  // );

  const updateAdminUser = useCallback(
    async (id: string, body: UpsertUser) => {
      const url = `/admin/users/${id}`;
      await api.put<UpsertUser>(url, body);
      api.mutateCache([`/admin/users`]);
    },
    [api]
  );

  // const deleteAdminUser = useCallback(
  //   async (userId: string): Promise<void> => {
  //     const url = `/admin/users/${userId}`;
  //     await api.del(url).then(() => {
  //       api.mutateCache([`/admin/users`]);
  //     });
  //   },
  //   [api]
  // );

  return {
    updateAdminUser,
    // insertAdminUser,
    useAdminUsers,
    getAdminUser,
    // deleteAdminUser,
  };
};
